   // src/ijewel-mini.js
// Lightweight wrapper – no hashed chunks will be generated
const IJ_MINI_CDN =
  'https://releases.ijewel3d.com/libs/mini-viewer/0.3.20/bundle.iife.js';

let ready;
export async function mountViewer(trigger) {
  if (!ready) {
    // load the IIFE once
    await new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = IJ_MINI_CDN;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    ready = window.IJewelMini; // global provided by the CDN bundle
  }

  // call the viewer’s mount helper supplied by the IIFE
  if (ready?.mountViewer) {
    return ready.mountViewer(trigger);
  }
}